import Model, {toModels, toProp} from "./Model";

/**
 *
 * @class Observation
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/model/Observation.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class Observation extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    this.component = toModels(Observation)

    this.code = toProp()

    this.valueQuantity = toProp()

    this.buildModel(modelData)
  }

  getValue(){
    this.checkProps(
      'valueQuantity.value',
    )

    return this.valueQuantity.value;
  }
}

export default Observation